<template>
    <div class="import-form">
        <a-steps v-model="current" type="navigation" size="small" :style="stepStyle">
            <a-step
                :title="$t('wp.selectContactFile')"
                :description="$t('wp.selectContactCsvOrExcel')"
                :status="current === 0 ? 'process' : 'wait'"
            />
            <a-step
                :title="$t('wp.importConfiguration')"
                :description="$t('wp.customizeFile')"
                :status="current === 1 ? 'process' : 'wait'"
            />
        </a-steps>
        <div v-if="current === 0" class="fileSelection">
            <div class="file-box" @click="openSelectFile">
                <div class="">
                    <a-icon type="file-excel" style="font-size: 50px; color: #08c" />
                </div>
                <div class="file-details">
                    <span v-if="file">{{ file.name }}</span>
                    <span>{{ $t("wp.selectFile") }}</span>
                    <span>{{ $t("wp.csvOrExcelFile") }}</span>
                </div>
            </div>
        </div>
        <div v-if="current === 1" class="configuration">
            <div class="left">
                <section class="general">
                    <div class="field">
                        <label> First Row Contains Header ? </label>
                        <a-switch v-model="firstRowContainsHeader" />
                    </div>

                    <div class="field" v-if="!excelMode">
                        <label> Seperator Character </label>
                        <a-select v-model="seperator">
                            <a-select-option value=",">Comma (,)</a-select-option>
                            <a-select-option value=";">Semicolon (;)</a-select-option>
                        </a-select>
                    </div>
                </section>
                <a-divider />
                <section class="number">
                    <label>Phone Number Selection <span class="text-danger">*</span> </label>
                    <div class="fields">
                        <div class="field">
                            <label> Column</label>
                            <a-select
                                :value="$_.get(getPhoneNumberCol(), 'headerUniqueId', '')"
                                :options="getSelectOptionsForColumns()"
                                @change="changePhoneColumn"
                            />
                        </div>
                        <div class="field">
                            <label> Attribute</label>
                            <a-input value="NUMBER" :disabled="true" />
                        </div>
                    </div>
                </section>
                <a-divider />
                <section class="attributes">
                    <label> Attributes</label>
                    <div class="attributes-items">
                        <div
                            class="attribute"
                            v-for="(attr, i) in columns.filter((x) => !x.isNumber)"
                            :key="`attr-${i}-${attr.headerUniqueId}`"
                        >
                            <div class="field">
                                <label> Column ({{ i + 1 }})</label>
                                <a-select
                                    v-model="columns[attr.index].headerUniqueId"
                                    :options="getSelectOptionsForColumns()"
                                />
                            </div>
                            <div class="field">
                                <label> Attribute</label>
                                <a-input v-model="columns[attr.index].attribute" />
                            </div>
                            <div class="field">
                                <label> Add To Attributes</label>
                                <a-switch v-model="columns[attr.index].include" />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div class="right">
                <section class="result">
                    <label>Example Result Preview</label>
                    <a-table
                        :columns="getTableDataSource().columns"
                        :data-source="getTableDataSource().rows"
                        :pagination="false"
                        :style="{ width: '100%' }"
                    />
                </section>

                <div class="alert-message">
                    <span>Numaralara ülke kodu girmeniz gereklidir.</span>
                    <span>Numaralarda ki rakam dışındaki her türlü karakterler tarafımızca otomatik temizlenir .</span>
                    <span
                        >Eğer numaralarınızın hepsi türkiye numaraları ise ülke kodu girmek zorunda değilsiniz aşağıdan
                        auto fix turkey number özelliğini açabilirsiniz .</span
                    >
                    <span>Numaralar en 6 haneli olmalı 6 haneden az olan numaralar kabul edilmeyecektir.</span>
                </div>
                <section class="footer mt-2">
                    <a-switch v-model="autoFixForTurkey" />
                    Auto Fix For Turkey Numbers (will add 90 or 9 country code if need)
                </section>
                <section class="footer">
                    <a-button @click="onCancelled">Cancel</a-button>
                    <a-button type="primary" @click="save" :loading="importing">
                        {{ importing ? "Importing" : "Import Contacts" }}
                    </a-button>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../utils/log2";
import { generateRandomId } from "../../../../../utils/session";
import _ from "lodash";
import readXlsxFile from "read-excel-file";

const log = log2("ImportContactsFromFile");
export default {
    name: "ImportContactsFromFile",
    props: {
        onCompleted: {
            type: Function,
            required: true,
        },
        onCancelled: {
            type: Function,
            required: true,
        },
        requiredAttributes: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            current: 0,
            stepStyle: {
                marginBottom: "20px",
            },
            lines: [],
            file: null,
            headers: [],
            columns: [],
            firstRowContainsHeader: true,
            seperator: ",",
            fileText: "",
            excelMode: false,
            importing: false,
            autoFixForTurkey: false,
        };
    },
    methods: {
        clearPhoneNumber(text) {
            return (text || "").toString().replace(/[^0-9]/g, "");
        },
        save() {
            this.importing = true;
            setTimeout(() => {
                const lines = this.firstRowContainsHeader ? this.lines.slice(1) : this.lines;

                const extendedCols = this.columns.map((x) => ({
                    ...x,
                    header: this.headers.find((h) => h.uniqueId === x.headerUniqueId),
                }));
                const missedAttributes = this.requiredAttributes.filter(
                    (x) => !extendedCols.find((y) => y.attribute === x)
                );
                const contacts = lines
                    .map((line) => {
                        const values = this.excelMode ? line : line.split(this.seperator);
                        const contact = {
                            number: "",
                            attributes: {},
                        };
                        extendedCols.forEach((col) => {
                            if (col.include) {
                                if (col.isNumber) {
                                    log("save current", values[col.index]);
                                    contact.number = this.clearPhoneNumber(
                                        (values[col.index] || "").toString().trim().toLowerCase()
                                    );
                                }

                                if (col.attribute !== "number") {
                                    contact.attributes[col.attribute] = (values[col.header.index] || "")
                                        .toString()
                                        .trim();
                                    missedAttributes.forEach((attr) => {
                                        contact.attributes[attr] = "";
                                    });
                                }
                            }
                        });

                        return _.isEmpty(contact.number) ? null : contact;
                    })
                    .filter((x) => x);
                log("save", contacts);
                if(!contacts.length) {
                    this.$message.error("Geçerli bir numara bulunamadı. Lütfen numara eşleştirmelerini kontrol edin.");
                    this.importing = false;
                    return;
                }
                this.onCompleted(contacts, this.autoFixForTurkey);
                this.importing = false;
            }, 10);
        },
        changePhoneColumn(value) {
            log("changePhoneColumn", value);
            this.columns = this.columns.map((col) => {
                if (col.isNumber) {
                    col.attribute = this.headers.find((x) => x.uniqueId === col.headerUniqueId).id;
                }
                col.isNumber = col.headerUniqueId === value;
                if (!col.include && col.isNumber) col.include = true;
                return col;
            });
        },
        getPhoneNumberCol() {
            return this.columns.find((col) => col.isNumber);
        },
        getAttributeHeaders() {
            const phoneCol = this.getPhoneNumberCol();
            const filteredHeaders = this.headers.filter((x) => _.get(phoneCol, "headerUniqueId", "") !== x.uniqueId);
            log("getAttributeHeaders", filteredHeaders);
            return filteredHeaders;
        },
        getSelectOptionsForColumns() {
            return this.headers.map((header) => {
                return {
                    label: header.name,
                    value: header.uniqueId,
                };
            });
        },
        openSelectFile() {
            let fileEl = document.createElement("input");
            fileEl.setAttribute("type", "file");
            fileEl.setAttribute(
                "accept",
                ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            );
            fileEl.onchange = async () => {
                let file = fileEl.files[0];
                log("selected file", file);
                const isExcel = !file.type.includes("text/csv");
                if (file) {
                    this.file = file;
                    log(file);
                    if (isExcel) {
                        readXlsxFile(file).then((rows) => {
                            this.lines = rows;
                            this.parseExcel(rows);
                            this.excelMode = true;
                            this.current = 1;
                        });
                    } else {
                        const text = await this.file.text();
                        this.fileText = text;
                        this.parseCSVText(text);
                        this.current = 1;
                        this.excelMode = false;
                    }
                } else {
                    this.file = null;
                }
            };
            fileEl.click();
        },
        toVariableName(name) {
            return name
                .toString()
                .trim()
                .toLowerCase()
                .split(" ")
                .map((x) => x.trim().replace(/[^a-z0-9_]/g, ""))
                .filter((x) => x.length > 0)
                .join("-");
        },
        parseCSVText(text) {
            let lines = text.split("\n");
            let result = [];
            this.headers = [];
            this.columns = [];
            this.headers = lines[0].split(this.seperator).map((name, index) => {
                const _name = this.firstRowContainsHeader ? name : `Column ${index + 1}`;
                const id = this.toVariableName(_name);
                return {
                    name: _name,
                    index,
                    id,
                    uniqueId: generateRandomId(4),
                };
            });
            this.columns = this.headers.map((h, i) => {
                return {
                    isNumber: h.index === 0,
                    attribute: h.index === 0 ? "number" : h.id,
                    include: true,
                    defaultValue: "",
                    headerUniqueId: h.uniqueId,
                    index: i,
                };
            });
            this.lines = lines;
        },
        parseExcel(lines) {
            this.headers = [];
            this.columns = [];
            this.headers = lines[0].map((name, index) => {
                const _name = this.firstRowContainsHeader ? name : `Column ${index + 1}`;
                const id = this.toVariableName(_name);
                return {
                    name: _name,
                    index,
                    id,
                    uniqueId: generateRandomId(4),
                };
            });
            this.columns = this.headers.map((h, i) => {
                return {
                    isNumber: h.index === 0,
                    attribute: h.index === 0 ? "number" : h.id,
                    include: true,
                    defaultValue: "",
                    headerUniqueId: h.uniqueId,
                    index: i,
                };
            });
            this.lines = lines;
        },
        getTableDataSource() {
            const lines = this.firstRowContainsHeader ? this.lines.slice(1) : this.lines;
            const extendedCols = this.columns.map((x) => ({
                ...x,
                header: this.headers.find((h) => h.uniqueId === x.headerUniqueId),
                priority: x.isNumber ? 1 : 0,
            }));
            const columns = _.orderBy(
                extendedCols
                    .filter((x) => x.include)
                    .map((x) => ({
                        title: x.isNumber ? "number" : x.attribute,
                        dataIndex: `${x.index}-${x.headerUniqueId}`,
                        key: `${x.index}-${x.headerUniqueId}`,
                        width: 50,
                        priority: x.priority,
                    })),
                ["priority"],
                ["desc"]
            );

            const rows = _.take(lines, 5).map((line) => {
                const values = this.excelMode ? line : line.split(this.seperator);
                const row = {};
                extendedCols.forEach((col) => {
                    row[`${col.index}-${col.headerUniqueId}`] = col.isNumber
                        ? this.clearPhoneNumber(values[col.header.index])
                        : values[col.header.index];
                });
                return row;
            });
            return {
                columns,
                rows,
            };
        },
    },
    watch: {
        seperator() {
            if (!this.excelMode) this.parseCSVText(this.fileText);
        },
        firstRowContainsHeader() {
            if (this.excelMode) this.parseExcel(this.lines);
            else this.parseCSVText(this.fileText);
        },
    },
};
</script>

<style lang="scss">
.import-form {
    .alert-message {
        display: flex;
        flex-direction: column;
        gap: 10px;
        background: #fff3cd; /* Light yellow background */
        color: #856404; /* Dark yellow text color */
        padding: 10px;
        border-radius: 4px;
    }

    .navs {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .fileSelection {
        display: flex;
        justify-content: center;
        align-items: center;

        .file-box {
            width: 100%;
            height: 200px;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            width: 300px;
            background: azure;

            .file-details {
                display: flex;
                flex-direction: column;
                gap: 10px;
            }
        }
    }

    .configuration {
        display: flex;
        gap: 10px;

        .left {
            width: 50%;
        }

        .right {
            width: 50%;
            overflow-y: auto;
            border-left: 1px solid #d9d9d9;
            padding-left: 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            section.footer {
                display: flex;
                justify-content: flex-end;
                gap: 10px;
            }
        }

        section.general {
            display: flex;
            gap: 20px;

            .field {
                display: flex;
                flex-direction: column;

                label {
                    font-size: 16px;
                    color: #232222;
                    font-weight: 600;
                }

                .ant-switch {
                    width: 10px;
                }
            }
        }

        section.number {
            display: flex;
            flex-direction: column;
            gap: 10px;

            label {
                font-size: 16px;
                color: #232222;
                font-weight: 600;
            }

            .fields {
                display: flex;
                gap: 20px;

                .field {
                    display: flex;
                    flex-direction: column;
                    min-width: 200px;

                    label {
                        font-size: 16px;
                        color: #232222;
                        font-weight: 600;
                    }

                    .ant-switch {
                        width: 10px;
                    }
                }
            }
        }

        section.attributes {
            display: flex;
            flex-direction: column;
            gap: 20px;

            label {
                font-size: 16px;
                color: #232222;
                font-weight: 600;
            }

            .attributes-items {
                display: flex;
                flex-direction: column;
                gap: 10px;

                .attribute {
                    display: flex;
                    gap: 20px;

                    .field {
                        display: flex;
                        flex-direction: column;
                        min-width: 200px;

                        label {
                            font-size: 16px;
                            color: #232222;
                            font-weight: 600;
                        }

                        .ant-switch {
                            width: 10px;
                        }
                    }
                }
            }
        }

        section.result {
            display: flex;
            flex-direction: column;
            gap: 20px;

            label {
                font-size: 16px;
                color: #232222;
                font-weight: 600;
            }
        }
    }
}
</style>
